export const TYPE = {
  LADDER_GAME: 'LADDER_GAME',
  LADDER_TSUME: 'LADDER_TSUME',
  LADDER_FUSEKI: 'LADDER_FUSEKI',
  LADDER_ENDGAME: 'LADDER_ENDGAME',
  COURSE: 'COURSE',
  GAME: 'GAME',
  VERIFICATION: 'VERIFICATION',
};
export default {TYPE};
